export const FLEET_EXPENSES_TUTORIAL_STEPS = [
  {
    target: '#fleet-expenses-module',
    title: 'Qué es Gastos de flota',
    content:
      'Acá registrás los gastos de cada transporte. Después podés ver el historial por unidad y cómo impacta en reportes.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-header',
    title: 'Cabecera del módulo',
    content:
      'Desde esta cabecera ubicás la empresa y empezás a cargar gastos en esta sección.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-form',
    title: 'Registrar gasto',
    content:
      'Acá cargás un gasto nuevo. Queda asociado a la unidad que elijas para verlo después en historial y reportes.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-category-field',
    title: 'Categoría del movimiento',
    content:
      'La categoría te ayuda a ordenar los gastos. Podés usar combustible, reparación, multa, peaje u otras que ya tengas cargadas.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-transport-field',
    title: 'Unidad operativa',
    content:
      'Elegí la unidad donde se hizo el gasto. Así el historial queda bien ordenado por transporte.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-categories',
    title: 'Catálogo de categorías',
    content:
      'En este bloque podés crear y ordenar las categorías que usás para cargar gastos.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-history',
    title: 'Historial de gastos',
    content:
      'El historial te muestra qué se cargó, cuándo, cuánto y en qué unidad. También podés filtrar por mes, categoría o transporte.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-chart',
    title: 'Lectura visual',
    content:
      'Este gráfico te ayuda a ver rápido en qué tipo de gasto se está yendo más dinero.',
    placement: 'top',
    disableBeacon: true,
  },
];
